module.exports = __webpack_public_path__ + "static/media/19.08.99832be0.jpg";